




















































































import { Component, Vue } from 'vue-property-decorator'
import { addNotice, queryNoticeById, editNotice } from '@/api/notice'
import ImageUpload from '@/components/ImgUpload/index.vue'

@Component({
  name: 'AddNotice',
  components: {
    ImageUpload
  }
})
export default class AddNotice extends Vue {
  private actionType = ''
  private title = '新增公告'
  private imageUrl = ''

  private ruleForm: {
    title: string;
    publisher: string;
    status: string;
    content: string;
    id: string | number;
    image: string;
  } = {
    title: '',
    publisher: '',
    status: '1',
    content: '',
    id: '',
    image: ''
  }

  get rules() {
    return {
      title: [
        { required: true, message: '请输入公告标题', trigger: 'blur' }
      ],
      publisher: [
        { required: true, message: '请输入发布人', trigger: 'blur' }
      ],
      content: [
        { required: true, message: '请输入公告详情', trigger: 'blur' }
      ],
      image: [
        { required: true, message: '请上传公告图片', trigger: 'change' }
      ]
    }
  }

  created() {
    this.actionType = this.$route.query.id ? 'edit' : 'add'
    if (this.$route.query.id) {
      this.title = '修改公告'
      this.init()
    }
  }

  private async init() {
    const id = this.$route.query.id
    queryNoticeById(id).then((res: any) => {
      if (res.data.code === 1) {
        this.ruleForm = res.data.data
        if (this.ruleForm.id && typeof this.ruleForm.id === 'string') {
          this.ruleForm.id = parseInt(this.ruleForm.id)
        }
        this.imageUrl = res.data.data.image
      } else {
        this.$message.error(res.data.msg || '获取公告信息失败')
      }
    })
  }

  private imageChange(url: string) {
    this.ruleForm.image = url
  }

  private submitForm(formName: string, st: boolean) {
    (this.$refs[formName] as any).validate(async (valid: boolean) => {
      if (valid) {
        const params = {
          ...this.ruleForm
        }
        
        if (this.actionType === 'add') {
          delete params.id
          addNotice(params)
            .then((res: any) => {
              if (res.data.code === 1) {
                this.$message.success('公告添加成功！')
                if (!st) {
                  this.$router.push({ path: '/notice' })
                } else {
                  this.ruleForm = {
                    title: '',
                    publisher: '',
                    status: '1',
                    content: '',
                    id: '',
                    image: ''
                  }
                  this.imageUrl = ''
                }
              } else {
                this.$message.error(res.data.msg || '操作失败')
              }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        } else {
          console.log('提交修改公告参数:', JSON.stringify(params));
          editNotice(params)
            .then((res: any) => {
              if (res.data.code === 1) {
                this.$message.success('公告修改成功！')
                this.$router.push({ path: '/notice', query: { refresh: 'true' } })
              } else {
                this.$message.error(res.data.msg || '操作失败')
              }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        }
      } else {
        return false
      }
    })
  }

  private goBack() {
    this.$router.push({ path: '/notice' })
  }
}
